import { createBrowserHistory } from 'history';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { DashboardButton } from './DashboardButton';
import { DashboardButtonPopup } from './DashboardButtonPopup';
import { List } from './Styles';

const ListItemSummary = ({ itemList, testId }) => {
  const history = createBrowserHistory({ forceRefresh: true });
  const handleClick = (item) => {
    const state = {
      auctionName: item?.auctionName,
      laneName: item?.laneName,
      uploadStatus: item?.value,
    };
    if (item.value === 'auctionTranscriptReport') {
      history.push(`/auction/${item.auctionID}/auctionTranscriptReport`, state);
    } else if (item.value === 'AuthorizedMembers') {
      history.push(`/auction/${item.auctionID}/authorizedMembers`, state);
    } else if (item.value === 'ProxyBids') {
      history.push(`/auction/${item.auctionID}/proxybids`, state);
    } else if (item.value === 'Members') {
      history.push(`/auction/${item.auctionID}/members`, state);
    } else if (item.value === 'UniqueMembers') {
      history.push(`/auction/${item.auctionID}/uniqueMembers`, state);
    } else {
      history.push(
        `/auction/${item.auctionID}/${item.value}/productImages`,
        state,
      );
    }
  };

  return (
    <List data-testid={testId}>
      {itemList?.map((item) =>
        item?.helpText ? (
          <DashboardButtonPopup
            key={`dashboardButtonPopup-${item?.text}-${testId}`}
            item={item}
            testId={testId}
            onClick={handleClick}
          />
        ) : (
          <DashboardButton
            key={`dashboardButton-${item?.text}-${testId}`}
            item={item}
            testId={testId}
            onClick={() => handleClick(item)}
          />
        ),
      )}
    </List>
  );
};

export default observer(ListItemSummary);
